// import React, { useState } from "react";
// import AppInput from "components/app-input";
// import AppItemDropdown from "components/app-item-dropdown";

import React, { useEffect, useState } from "react";
  import { BarChart, Bar, ResponsiveContainer, LabelList, Cell } from "recharts";

// import InReview from "assets/images/pages/in-review.png";
import InitialApproval from "assets/images/pages/initial-approval.png";
import Approved from "assets/images/pages/approved.png";
import LiveBriefing from "assets/images/pages/live-briefing.png";
import SignAgreement from "assets/images/pages/sign-agreement.png";
import AppReactTable from "components/app-react-table";
import { FiSearch } from "react-icons/fi";
import { BiTask, BiSpreadsheet, BiCalendarEdit  } from "react-icons/bi";
import { AiOutlineAlert } from "react-icons/ai";
import { IoClose } from "react-icons/io5";
import { MdPendingActions  } from "react-icons/md";
import AppButton from "components/app-button";
import Badge from '@material-ui/core/Badge';

// import { useDispatch } from "react-redux";
import pathnames from "routes/pathnames";
// import { useEffect } from "react";
import { useHistory } from "react-router-dom";

// commons
import CONSTANSTS from "common/constansts";
import "../../node_modules/bootstrap/dist/js/bootstrap.min.js";


const PageHomePage = (from) => {
  //   // tableSearchFilter are filter payload to be send to backend

  //tableCoumn is to create table column
  const tableColumn = [
    {
      id: "loanApplicationReferenceNo",
      // header is the table header for id column
      Header: () => {
        return (
          // <div onClick={() => headerFilterClick(header)} className="react-table__header">
          <span className="react-table__header-title">Application ID</span>
          // <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
          //     <span className="react-table__icon"></span>
          // </div>
          // </div>
        );
      },
      // accessor will list out the table data based on the data key. In this case, the mockData key of id
      accessor: "loanApplicationReferenceNo",
      // searchFilterValue is the column value that will send to BE to inform BE to sort according to which column. it is use to update tableSearchFilter.searchValue
      searchFilterValue: "loanApplicationReferenceNo",
      // minWidth, width, maxWidth is to adjust the width of this current column
      // minWidth: 200,
      width: 200,
    },
    {
      id: "meetingTime",
      Header: () => {
        return (
          // <div onClick={() => headerFilterClick(header)} className="react-table__header">
          <span className="react-table__header-title">Time</span>
          //     <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
          //         <span className="react-table__icon"></span>
          //     </div>
          // </div>
        );
      },
      searchFilterValue: "meetingTime",
      accessor: "meetingTime",
      // minWidth: 150,
      width: 150,
    },
    {
      id: "assignedStaff",
      Header: () => {
        return (
          // <div onClick={() => headerFilterClick(header)} className="react-table__header">
          <span className="react-table__header-title">PIC</span>
          //     <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
          //         <span className="react-table__icon"></span>
          //     </div>
          // </div>
        );
      },
      searchFilterValue: "assignedStaff",
      accessor: "assignedStaff",
      // minWidth: 220,
      width: 220,
    },

    {
      id: "button",
      Header: "",
      Cell: (row) => {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => viewLoanApplicationDetailPage(row.row.original)}
              className="react-table__search-button"
            >
              <FiSearch size={24} />
            </button>
          </div>
        );
      },
      // minWidth: 70,
      width: 70,
    },
  ];

  // const tableColumnUnattended = [
  //   {
  //     id: "loanApplicationReferenceNo",
  //     // header is the table header for id column
  //     Header: () => {
  //       return (
  //         // <div onClick={() => headerFilterClick(header)} className="react-table__header">
  //         <span className="react-table__header-title">Application ID</span>
  //         // <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
  //         //     <span className="react-table__icon"></span>
  //         // </div>
  //         // </div>
  //       );
  //     },
  //     // accessor will list out the table data based on the data key. In this case, the mockData key of id
  //     accessor: "loanApplicationReferenceNo",
  //     // searchFilterValue is the column value that will send to BE to inform BE to sort according to which column. it is use to update tableSearchFilter.searchValue
  //     searchFilterValue: "loanApplicationReferenceNo",
  //     // minWidth, width, maxWidth is to adjust the width of this current column
  //     // minWidth: 200,
  //     width: 200,
  //   },
  //   {
  //     id: "unattendedNote",
  //     Header: () => {
  //       return (
  //         // <div onClick={() => headerFilterClick(header)} className="react-table__header">
  //         <span className="react-table__header-title">Unattended Note</span>
  //         //     <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
  //         //         <span className="react-table__icon"></span>
  //         //     </div>
  //         // </div>
  //       );
  //     },
  //     searchFilterValue: "unattendedNote",
  //     accessor: "unattendedNote",
  //     // minWidth: 150,
  //     width: 150,
  //   },
  //   {
  //     id: "assignedStaff",
  //     Header: () => {
  //       return (
  //         // <div onClick={() => headerFilterClick(header)} className="react-table__header">
  //         <span className="react-table__header-title">PIC</span>
  //         //     <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
  //         //         <span className="react-table__icon"></span>
  //         //     </div>
  //         // </div>
  //       );
  //     },
  //     searchFilterValue: "assignedStaff",
  //     accessor: "assignedStaff",
  //     // minWidth: 220,
  //     width: 220,
  //   },

  //   {
  //     id: "button",
  //     Header: "",
  //     Cell: (row) => {
  //       return (
  //         <div onClick={(e) => e.stopPropagation()}>
  //           <button
  //             onClick={() => viewPage(row.row.original)}
  //             className="react-table__search-button"
  //           >
  //             <FiSearch size={24} />
  //           </button>
  //         </div>
  //       );
  //     },
  //     // minWidth: 70,
  //     width: 70,
  //   },
  // ];

  // const dispatch = useDispatch();

  const viewLoanApplicationDetailPage = async (value) => { 
    history.push(pathnames.pageLoanApplicationView.replace(":staffId", value.loanApplicationId.toString()))
  }

  const viewLoanApplicationDetailPageWithID = async (value) => { 
    history.push(pathnames.pageLoanApplicationView.replace(":staffId", value.toString()))
  }

  const viewLoanContractDetailPage = async (value) => {
    history.push(
      pathnames.pageLoanContractView.replace(":contractId", value.id.toString())
    );
  };

  const viewMerchantDetailPage = async (value) => {
    history.push(
      pathnames.pageMerchantView.replace(":merchantId", value.toString())
    );
  };


  //customer view path
  const viewCustomerDetailPage = async (value) => {
    history.push(
      pathnames.pageCustomerView.replace(":customerId", value.toString())
    );
  };

  //Merchant Discovery view
  const viewMerchantDiscovery = async (value) => {
    history.push(
      pathnames.pageMerchantDiscovery.replace(":customerId", value.toString())
    );
  };

  // Merchant Discovery Addresses view 
  const viewMerchantDiscoveryAddresses = async (value) => {
    history.push(
      pathnames.pageMerchantDiscoveryAddresses.replace(":addressId", value.toString())
    );
  };

  const initialValue = {
    staffName: "",
    // inReviewApplication: "",
    initialApprovedApplication: "",
    kycInterviewApplication: "",
    approvedApplication: "",
    liveBriefingApplication: "",
    signAgreementApplication: "",
    totalActiveContracts: "",
    totalCustomers: "",
    totalActiveMerchants: "",
    totalNewMerchantTransactions: "",
    upcomingInterviews: [
      {
        loanApplicationId: "",
        loanApplicationReferenceNo: "",
        meetingTime: "",
        assignedStaff: "",
      },
    ],
    upcomingLiveBriefings: [
      {
        loanApplicationId: "",
        loanApplicationReferenceNo: "",
        meetingTime: "",
        assignedStaff: "",
      },
    ],
  };

  const [appList, setAppList] = useState([]);
  const [unattendedList, setUnattendedList] = useState([]);
  const [merchantUpdatePendingApprovalList, setMerchantUpdatePendingApprovalList] = useState([]);
  const [merchantDiscoveryApprovalList, setMerchantDiscoveryApprovalList] = useState([]);
  const [customerUpdateList, setCustomerUpdateList] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [accessContractList, setAccessContractList] = useState({
    view_contract_details: false,
  });
  useEffect(() => {
    let contractAccess = null;
    contractAccess = JSON.parse(localStorage.getItem("accessMatrix"));
    if (contractAccess) {
      console.log("contractAccess.accessMatrix.Loan_Contract_List", contractAccess.accessMatrix.Loan_Contract_List)
      setAccessContractList({
        view_contract_details: contractAccess.accessMatrix.Loan_Contract_Detail.view_contract_detail,
      });
    }
      fetchUnattendedList();
      fetchMerchantUpdatePendingApprovalList();
      fetchCustomerUpdateList();
      fetchMerchantDiscoveryApprovalList();
  }, []);

  useEffect(async () => {
    //const fetchData = async () => {
      let token = null;
      token = localStorage.getItem("@storage_token");
      try {
        fetch(
          process.env.REACT_APP_API_URL +
            CONSTANSTS.ENDPOINT_PATH.GET_CONTRACT_LIST,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "*/*",
              "Accept-language": "en", "X-DEVICE-OS": "Web",
              Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
              criteria: {
                dateFrom: tableSearchFilter.dateFrom,
                dateRangeType: tableSearchFilter.dateRangeType,
                dateTo: tableSearchFilter.dateTo,
                keyword: tableSearchFilter.keyword,
                status: tableSearchFilter.status,
              },
              pageNumber: tableSearchFilter.pageNo,
              pageSize: tableSearchFilter.pageSize,
              sortDirection: tableSearchFilter.sortDir,
              sortKey: tableSearchFilter.sortBy,
            }),
          }
        )
          .then((response) => response.json())
          .then((json) => {
            let result = json.result;
            console.log("Loan Contract Pending to Sign - List:", result.data);
            setAppList(result.data);
            setLoadingData(false);
            //setPaginationLocker(false);
            if (result.data.length === 0) {

              //setExportBtn("dimmed");
            } else {
              if (from.location.state == 'contract-view') {
                setShowNewLoanContract(true);
              }
             // setLoadingData(true);
              //setExportBtn("orange");
            }
          });
      } catch (error) {
        console.log("Loan Contract Pending to Sign - List:", error);
      }
      
   // };
   // fetchData();
  }, []);

  const fetchUnattendedList = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    try {
      fetch(
        process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GET_UNATTENDED_LIST,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en", "X-DEVICE-OS": "Web",
            Authorization: "Bearer " + token,
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          let result = json.result;
          console.log("Unattended List", result.data);
          setUnattendedList(result.data);
          setLoadingData(false);
          //setPaginationLocker(false);
          if (result.data.length === 0) {
            
            //setExportBtn("dimmed");
          } else {
            // setLoadingData(true);
            //setExportBtn("orange");
          }
        });
    } catch (error) {
      console.log("Unattended List", error);
    }
  }

  const fetchMerchantUpdatePendingApprovalList = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    try {
      fetch(
        process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GET_MERCHANT_UPDATE_APPROVAL_LIST,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en", "X-DEVICE-OS": "Web",
            Authorization: "Bearer " + token,
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          let result = json.result;
          console.log("Merchant Update Pending Approval List", result.data);
          setMerchantUpdatePendingApprovalList(result.data);
          setLoadingData(false);
          //setPaginationLocker(false);
          if (result.data.length === 0) {
            
            //setExportBtn("dimmed");
          } else {
            // setLoadingData(true);
            //setExportBtn("orange");
          }
        });
    } catch (error) {
      console.log("Merchant Update Pending Approval List", error);
    }
  }

  //GET Customer Update List
  const fetchCustomerUpdateList = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    try {
      fetch(
        process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GET_CUSTOMER_UPDATE_LIST,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en", "X-DEVICE-OS": "Web",
            Authorization: "Bearer " + token,
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          let result = json.result;
          console.log("Customer Update List", result);
          setCustomerUpdateList(result.data);
          setLoadingData(false);
        });
    } catch (error) {
      console.log("Customer Update List", error);
    }
  }

  //GET Merchant Discovery Approval List
  const fetchMerchantDiscoveryApprovalList = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    try {
      fetch(
        process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GET_MERCHANT_DISCOVERY_APPROVAL_LIST,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en", "X-DEVICE-OS": "Web",
            Authorization: "Bearer " + token,
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          let result = json.result;
          console.log("Merchant Discovery Approval List", result);
          setMerchantDiscoveryApprovalList(result.data);
          setLoadingData(false);
        });
    } catch (error) {
      console.log("Merchant Discovery Approval List", error);
    }
  }

  const [tableSearchFilter] = useState({
    // insert the key value requested by BE here
    pageNo: 1,
    pageSize: 50,
    sortDir: "DESCENDING",
    dateRangeType: null,
    dateFrom: "string",
    dateTo: "string",
    keyword: "",
    status: "NEW",
    sortBy: "contractDate"
   });

  //  const headerFilterClick = (header) => {
  //   let column = header.column;
  //   if (tableSearchFilter.sortBy === column.searchFilterValue) {
  //     // if click on the same column previously clicked will enter here
  //     if (tableSearchFilter.sortDir === "ASCENDING") {
  //       // if previously the column is sort by ascending order, sortDir will change to sort by descending order
  //       setTableSearchFilter({
  //         ...tableSearchFilter,
  //         sortBy: column.searchFilterValue,
  //         sortDir: "DESCENDING",
  //         pageNo: tableSearchFilter.pageNo,
  //         status: tableSearchFilter.status,
  //       });
  //     } else {
  //       // if previously the column is sort by descending order, sortDir will change to sort by ascending order
  //       setTableSearchFilter({
  //         ...tableSearchFilter,
  //         sortBy: column.searchFilterValue,
  //         sortDir: "ASCENDING",
  //         pageNo: tableSearchFilter.pageNo,
  //         status: tableSearchFilter.status,
  //       });
  //     }
  //   } else {
  //     // if click on a new column, it will sort by ascending order with the column value (column.searchFilterValue)
  //     setTableSearchFilter({
  //       ...tableSearchFilter,
  //       sortBy: column.searchFilterValue,
  //       sortDir: "ASCENDING",
  //       pageNo: tableSearchFilter.pageNo,
  //       status: tableSearchFilter.status,
  //     });
  //   }
  // };


  const [showUnattended, setShowUnattended] = useState(false);
  const [showNewLoanContract, setShowNewLoanContract] = useState(false);
  const [showPendingApproval, setShowPendingApproval] = useState(false);
  const [showCustomerUpdateList, setShowCustomerUpdateList] = useState(false);
  const [showMerchantDiscoveryApprovalList, setShowMerchantDiscoveryApprovalList] = useState(false);
  const [data, setData] = useState(initialValue);

  const displayBarData = [
    {
      name: "Initial Approval",
      value: data.initialApprovedApplication,
    },
    {
      name: "KYC Interview",
      value: data.kycInterviewApplication,
    },
    {
      name: "Approved",
      value: data.approvedApplication,
    },
    {
      name: "Live Briefing",
      value: data.liveBriefingApplication,
    },
    {
      name: "Sign Agreement",
      value: data.signAgreementApplication,
    },
  ];

  const history = useHistory();

  useEffect(async () => {
    // const fetchData = async () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    try {
      // fetch("http://49.0.203.50/ivc-app/bo/common/api/v1/dashboard", {
      fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.COMMON_DASHBOARD, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => response.json())
        .then((json) => {
          let result = json.result;
          setData(result);
        });
      // dispatch((response));
    } catch (error) {
      console.log(error);
    }
  }, []);

  const icons = [
    {
      id: 1,
      name: "Initial Approval",
      src: InitialApproval,
    },
    {
      id: 2,
      name: "KYC Interview",
      src: LiveBriefing,
    },
    {
      id: 3,
      name: "Approved",
      src: Approved,
    },
    {
      id: 4,
      name: "Live Briefing",
      src: LiveBriefing,
    },
    {
      id: 5,
      name: "Sign Agreement",
      src: SignAgreement,
    },
  ];

  const disbursementTabView = () => {
    history.push(pathnames.pageTransaction);
    sessionStorage.setItem("disbursementTab", "2tab")
  }

  function PopupUnattendedLoanApplication(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-content">
          <IoClose size={24} style={{ cursor: "pointer", float: "right" }} onClick={() => {setShowUnattended(false)}} />
          {/* <AppReactTable columns={tableColumnUnattended} data={mockDataUnattended} /> */}
          {/* {props.children} */}
          <p style={{ textAlign: "initial" }}>Unattended Loan Application</p>
          <div className="table-invoice">
            <table style={{ width: "100%", textAlign: "left", border: "1px solid black" }}>
              <thead className="tr-head">
                <tr
                  style={{
                    backgroundColor: "856E49",
                    color: "white",
                    textDecoration: "underline",
                  }}
                >
                  <th style={{ width: "10%" }}>Application ID</th>
                  <th style={{ width: "10%" }} className="th">Application Name</th>
                  <th style={{ width: "10%" }} className="th">Loan Amount</th>
                  <th style={{ width: "10%" }}>Status</th>
                  <th style={{ width: "10%" }} className="th">Unattended Remark</th>
                  <th style={{ width: "10%" }} className="th">PIC</th>
                  <th style={{ width: "10%" }}></th>
                </tr>
              </thead>
              <tbody className="tr-body">
                {unattendedList.map((item, index) => (
                  <tr key={index}>
                    <td>{item.referenceNumber}</td>
                    <td className="th">{item.customerName}</td>
                    <td className="th">{item.loanAmount}</td>
                    <td>{item.status}</td>
                    <td className="th">{item.unattendedRemark}</td>
                    <td className="th">{item.officerName}</td>
                    <td>
                    <div onClick={(e) => e.stopPropagation()}>
                      <button
                        onClick={() => viewLoanApplicationDetailPageWithID(item.id)}
                        className="search-button"
                      >
                        <FiSearch size={24} />
                      </button>
                    </div>
                    </td>
                  </tr>
                  
                ))}
                
                {unattendedList.length === 0 &&
                 <tr>
                  <td className="th"></td>
                  <td className="th"></td>
                  <td className="th"></td>
                  <td style={{textAlign:"end", fontWeight:"bold"}}>No data is found !</td>
                 </tr>
                  }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }

  function PopupNewLoanContract(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-content">
          <IoClose size={24} style={{ cursor: "pointer", float: "right" }} onClick={() => {setShowNewLoanContract(false)}} />
          {/* <AppReactTable columns={tableColumnUnattended} data={mockDataUnattended} /> */}
          {/* {props.children} */}
          <p style={{ textAlign: "initial" }}>Loan Contract Pending to Sign</p>
          <div className="table-invoice">
          <table style={{ width: "100%", textAlign: "left", border: "1px solid black" }}>
              <thead className="tr-head">
                <tr
                  style={{
                    backgroundColor: "856E49",
                    color: "white",
                    textDecoration: "underline",
                  }}
                >
                  <th style={{ width: "10%" }} >Application ID</th>
                  <th style={{ width: "10%" }} className="th">Applicant Name</th>
                  <th style={{ width: "10%" }} className="th">Contract Date</th>
                  <th style={{ width: "10%" }} className="th">PIC</th>
                  <th style={{ width: "10%" }}>Status</th>
                  <th style={{ width: "10%" }}></th>
                </tr>
              </thead>
              <tbody className="tr-body"> 
              {loadingData? (
            <td>Loading Please wait...</td>
            ) : (  
              appList.map((appList) => { 
                return(        
                   <tr key={appList}>
                    <td>{appList.referenceNumber}</td>
                    <td className="th">{appList.applicantName}</td>
                    <td className="th">{appList.contractDate}</td>
                    <td className="th">{appList.officer}</td>
                    <td>{appList.status}</td>
                    <td>
                    {accessContractList.view_contract_details && (
                    <div onClick={(e) => e.stopPropagation()}>
                    <button
                    onClick={() => viewLoanContractDetailPage(appList)}
                    className="search-button"
                    >
                  <FiSearch size={24} />
                    </button>
                    </div>
                    )}
                    </td>                
                  </tr>
                )
                })
                )} 
                 {appList.length === 0 &&
                 <tr>
                  <td className="th"></td>
                  <td className="th"></td>
                  <td style={{textAlign:"end", fontWeight:"bold"}}>No data is found !</td>
                 </tr>
                  }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }

  function PopupPendingApproval(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-content">
          <IoClose size={24} style={{ cursor: "pointer", float: "right" }} onClick={() => {setShowPendingApproval(false)}} />
          {/* <AppReactTable columns={tableColumnUnattended} data={mockDataUnattended} /> */}
          {/* {props.children} */}
          <p style={{ textAlign: "initial" }}>Merchant Pending Approval</p>
          <div className="table-invoice">
            <table style={{ width: "100%", textAlign: "left", border: "1px solid black" }}>
              <thead className="tr-head">
                <tr
                  style={{
                    backgroundColor: "856E49",
                    color: "white",
                    textDecoration: "underline",
                  }}
                >
                  <th style={{ width: "10%" }}>Merchant ID</th>
                  <th style={{ width: "10%" }} className="th">Merchant Name</th>
                  <th style={{ width: "10%" }} className="th">Update Date</th>
                  <th style={{ width: "10%" }}>Status</th>
                  <th style={{ width: "10%" }}></th>
                </tr>
              </thead>
              <tbody className="tr-body">
                {merchantUpdatePendingApprovalList.map((item, index) => (
                  <tr key={index}>
                    <td>{item.referenceNumber}</td>
                    <td className="th">{item.name}</td>
                    <td className="th">{item.updatedDate}</td>             
                    <td>{item.status}</td>
                    <td>
                    <div onClick={(e) => e.stopPropagation()}>
                      <button
                        onClick={() => viewMerchantDetailPage(item.id)}
                        className="search-button"
                      >
                        <FiSearch size={24} />
                      </button>
                    </div>
                    </td>
                  </tr>
                ))}
                  {merchantUpdatePendingApprovalList.length === 0 &&
                 <tr>
                  <td className="th"></td>
                  <td className="th"></td>
                  <td style={{textAlign:"end", fontWeight:"bold"}}>No data is found !</td>
                 </tr>
                  }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }

  //Update List
  function PopupCustomerUpdateList(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-content">
          <IoClose size={24} style={{ cursor: "pointer", float: "right" }} onClick={() => {setShowCustomerUpdateList(false)}} />
          {/* <AppReactTable columns={tableColumnUnattended} data={mockDataUnattended} /> */}
          {/* {props.children} */}
          <p style={{ textAlign: "initial" }}>Customer Update List</p>
          <div className="table-invoice">
            <table style={{ width: "100%", textAlign: "left", border: "1px solid black" }}>
              <thead className="tr-head">
                <tr
                  style={{
                    backgroundColor: "856E49",
                    color: "white",
                    textDecoration: "underline",
                  }}
                >
                  <th style={{ width: "10%" }}>Customer ID</th>
                  <th style={{ width: "10%" }} className="th">Customer Name</th>
                  <th style={{ width: "10%" }} className="th">Username</th>
                  <th style={{ width: "10%" }}>Status</th>
                  <th style={{ width: "10%" }} className="th">Mobile Num</th>
                  <th style={{ width: "10%" }} className="th">Temperory Mobile Num</th>
                  <th style={{ width: "10%" }}></th>
                </tr>
              </thead>
              <tbody className="tr-body">
                {customerUpdateList.map((item, index) => (
                  <tr key={index}>
                    <td>{item.id}</td>
                    <td className="th">{item.name}</td>
                    <td className="th">{item.username}</td>             
                    <td>{item.status}</td>
                    <td className="th">{item.mobileNumber}</td>
                    <td className="th">{item.tempMobileNumber}</td>
                    <td>
                    <div onClick={(e) => e.stopPropagation()}>
                      <button
                        onClick={() => viewCustomerDetailPage(item.id)}
                        className="search-button"
                      >
                        <FiSearch size={24} />
                      </button>
                    </div>
                    </td>
                  </tr>
                ))}
                  {customerUpdateList.length === 0 &&
                 <tr>
                  <td className="th"></td>
                  <td className="th"></td>
                  <td className="th"></td>
                  <td style={{textAlign:"end", fontWeight:"bold"}}>No data is found !</td>
                 </tr>
                  }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }

  //GET Merchant Discovery Approval List
  function PopupMerchantDiscoveryApproval(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-content">
          <IoClose size={24} style={{ cursor: "pointer", float: "right" }} onClick={() => {setShowMerchantDiscoveryApprovalList(false)}} />
          {/* <AppReactTable columns={tableColumnUnattended} data={mockDataUnattended} /> */}
          {/* {props.children} */}
          <p style={{ textAlign: "initial" }}>Merchant Discovery Pending Approval</p>
          <div className="table-invoice">
            <table style={{ width: "100%", textAlign: "left", border: "1px solid black" }}>
              <thead className="tr-head">
                <tr
                  style={{
                    backgroundColor: "856E49",
                    color: "white",
                    textDecoration: "underline",
                  }}
                >        
                  <th style={{ width: "10%" }} className="th">Merchant Name</th>
                  <th style={{ width: "10%" }} className="th">Update Date</th>
                  <th style={{ width: "10%" }}>Status</th>
                  <th style={{ width: "10%" }}></th>
                </tr>
              </thead>
              <tbody className="tr-body">
                {merchantDiscoveryApprovalList.map((item, index) => (
                  <tr key={index}>
                    <td className="th">{item.merchantName}</td>
                    <td className="th">{item.dateUpdated}</td>             
                    <td>{item.status}</td>
                    <td>
                    <div onClick={(e) => e.stopPropagation()}>
                    {item.discoveryId === null ? (
                      <button
                        onClick={() => viewMerchantDiscovery(item.id)}
                        className="search-button"
                      >
                        <FiSearch size={24} />
                      </button>
                    ) : (
                      <button
                        onClick={() => viewMerchantDiscoveryAddresses(item.discoveryId)}
                        className="search-button"
                      >
                        <FiSearch size={24} />
                      </button>
                    )}
                  </div>
                    </td>
                  </tr>
                ))}
                  {merchantDiscoveryApprovalList.length === 0 &&
                 <tr>
                  <td className="th"></td>
                
                  <td style={{textAlign:"end", fontWeight:"bold"}}>No data is found !</td>
                 </tr>
                  }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }
 
  return (
    <div className="page-home-page">
      <div className="row home-page">
        <div className="row home-page__top">
          <div className="col-2 home-page__title">Home </div>
          <div className="col-1 home-page__vertical-line"></div>
          <div className="col-4 home-page__subtitle">
            <div className="username"> Hi {data.staffName}</div>
            <div> Welcome Back!</div>
          </div>
          <div className="col-4 home-page__icon">
            <Badge badgeContent={unattendedList.length} color="secondary" style={{marginRight:"15px"}}>
            <AiOutlineAlert size={50} style={{ cursor: 'pointer'}} onClick={() => {setShowUnattended(true)}} />
            </Badge>
            <Badge badgeContent={appList.length} color="secondary" style={{marginRight:"15px"}}>
            <BiTask size={50} style={{ cursor: 'pointer'}} onClick={() => {setShowNewLoanContract(true)}} />
            </Badge>
            <Badge badgeContent={merchantUpdatePendingApprovalList.length} color="secondary" style={{marginRight:"15px"}}>
            <MdPendingActions size={50} style={{ cursor: 'pointer' }} onClick={() => {setShowPendingApproval(true)}} />
            </Badge>
            <Badge badgeContent={customerUpdateList.length} color="secondary" style={{marginRight:"15px"}}>
            <BiSpreadsheet size={50} style={{ cursor: 'pointer' }} onClick={() => {setShowCustomerUpdateList(true)}} />
            </Badge>
            <Badge badgeContent={merchantDiscoveryApprovalList.length} color="secondary" style={{marginRight:"15px"}}>
            <BiCalendarEdit  size={50} style={{ cursor: 'pointer' }} onClick={() => {setShowMerchantDiscoveryApprovalList(true)}} />
            </Badge>
          </div>          
        </div>
      </div>

      <PopupUnattendedLoanApplication trigger={showUnattended}></PopupUnattendedLoanApplication>
      <PopupNewLoanContract trigger={showNewLoanContract}></PopupNewLoanContract>
      <PopupPendingApproval trigger={showPendingApproval}></PopupPendingApproval>
      <PopupCustomerUpdateList trigger={showCustomerUpdateList}></PopupCustomerUpdateList>
      <PopupMerchantDiscoveryApproval trigger={showMerchantDiscoveryApprovalList}></PopupMerchantDiscoveryApproval>

      <div className="row body-content">
        <div className="row justify-content">
          <div className="col-5  body-content__body-content-left order-2 order-md-1">
            <div className="row">
              <div className="title">Application Status (To-Date)</div>
              <div className="multiple-bar">
                <ResponsiveContainer width="100%" height="65%">
                  <BarChart
                    width={140}
                    height={40}
                    data={displayBarData}
                    margin={{ top: 50 }}
                  >

                    <Bar
                      dataKey="value"
                      background={{fill:"#ededed",radius:[10, 10, 0, 0],strokeWidth:"1"}}
                      radius={[10, 10, 0, 0]}
                      isAnimationActive={false}
                    >
                      {displayBarData.map((entry, index) => (
                        <Cell
                          key={index}
                          fill={
                            entry.value !== 0 && index % 2 === 0
                              ? "#a28559"
                              : "#f5903d"
                          }
                          style={{
                            filter: `drop-shadow(-2px -1px 1px #ffffff)`
                          }}
                      
                          
                        />
                      ))}
                      <LabelList dataKey="value" position="top" />
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
                <div className="row  bar-xaxis ">
                  {icons.map((p) => {
                    return p.id !== 5 ? (
                      <div className="icons-box" key={p.id}>
                        
                        <img
                          width="100px"
                          height="100px"
                          
                          src={p.src}
                          alt="Loading.."
                        />
                        <div>{p.name}</div>
                      </div>
                    ) : (
                      <div className="icons-last-box" key={p.id}>
                        <img
                          width="100px"
                          height="100px"
                          src={p.src}
                          alt="Loading.."
                        />

                        <div>{p.name}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="row mt-5 bottom-left">
              <div className="col">
                <div className="row bottom-left-title">
                  <div className="col-5 ">Total Active Contracts</div>
                  <div className="col-7 bottom-left-value">
                    {data.totalActiveContracts}
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="row bottom-left-title">
                  <div className="col-5 ">Number of Customers</div>
                  <div className="col-7 bottom-left-value">
                    {data.totalCustomers}
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="row bottom-left-title">
                  <div className="col-5 ">Number of Active Merchants</div>
                  <div className="col-7 bottom-left-value">
                    {data.totalActiveMerchants}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-5 body-content__body-content-right order-1 order-md-2">
            <div className="row">
              <div className="multiple-schedule">
                <div className="table-content">
                  <div className="row ">
                    <span className="table-title">
                      Upcoming KYC Interview Schedule:
                    </span>
                    {/* remove the class below will affected the search icons as it is rely on page-loan-application-list css created */}
                    <div
                      className="page-loan-application-list__react-table-wrapper"
                      style={{ marginTop: "10px" }}
                    >
                      {data.upcomingInterviews !== undefined &&
                      data.upcomingInterviews !== undefined ? (
                        <AppReactTable
                          columns={tableColumn}
                          data={data.upcomingInterviews}
                          headerClass="dashBoardHeader"
                          headerRowClass="dashBoardHeader__row"
                          rowHeaderClass="dashBoardHeader__row-header"
                          bodyClass="dashBoardBody"
                          bodyRowClass="dashBoardBody__row"
                          bodyDataClass="dashBoardBody__row-data"
                        />
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>

                  <div className="row mt-4">
                    <span className="table-title">
                      Upcoming Live Briefing Schedule:
                    </span>
                    {/* remove the class below will affected the search icons as it is rely on page-loan-application-list css created */}

                    <div
                      className="page-loan-application-list__react-table-wrapper"
                      style={{ marginTop: "10px" }}
                    >
                      {data.upcomingLiveBriefings !== undefined &&
                      data.upcomingLiveBriefings !== undefined ? (
                        <AppReactTable
                          columns={tableColumn}
                          data={data.upcomingLiveBriefings}
                          headerClass="dashBoardHeader"
                          headerRowClass="dashBoardHeader__row"
                          rowHeaderClass="dashBoardHeader__row-header"
                          bodyClass="dashBoardBody"
                          bodyRowClass="dashBoardBody__row"
                          bodyDataClass="dashBoardBody__row-data"
                        />
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-5 bottom-right">
              <div className="col">
                <div className="row bottom-right-title">
                  <div className="col-3 ">New Merchants Transaction</div>
                  <div className="col-5 bottom-right-value">
                    {data.totalNewMerchantTransactions}
                  </div>
                  <div className="col-4 bottom-right-button">
                    <AppButton colorType="orange" label="View List" onClick={disbursementTabView} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHomePage;
